import { examsHashtags } from "../components/card/TrendsCard/exams-hashtags";
import { studentsBanners } from "../components/card/TrendsCard/students-banners";
import { studentsHashtags } from "../components/card/TrendsCard/students-hashtags";
import { formatHashtagDisplay } from "./formatHashtag";

const RideDesc =
  "Reviews, stories, and rider experiences with community driver";
const RideBanner = "/hashtag-banners/ride-banner.jpg";
const Ride2Banner = "/hashtag-banners/ride2-banner.jpg";
const MarketBanner = "/hashtag-banners/market-banner.jpg";
const QuizBanner = "/hashtag-banners/quiz-banner.jpg";
const NclexRnBanner = "/hashtag-banners/exams/nclex-rn.webp";
const PEBCBanner = "/hashtag-banners/exams/pebc.webp";
const RexPnBanner = "/hashtag-banners/exams/rex-pn.jpeg";
const DefaultBanner = "/hashtag-banners/default.webp";

const infoHashtags = {
  ...studentsHashtags,
  ...examsHashtags,
  market: {
    desc: "Buy, sell, and trade with people in your community",
  },
};

export const getHashtagMetadata = (tag, hashtagData = null) => {
  // normalize tag (remove # if present, though we expect clean tag here)
  const cleanTag = tag.replace(/^#/, "");
  const lowerTag = cleanTag.toLowerCase();

  // --- Description ---
  let desc = hashtagData?.description || "";

  if (!desc) {
    if (lowerTag.endsWith("rides")) {
      desc = `${RideDesc} ${cleanTag.slice(0, -5)}`;
    } else if (infoHashtags[cleanTag]) {
      desc = infoHashtags[cleanTag].desc;
    }
  }

  // --- Banner ---
  let banner = hashtagData?.image || null;

  if (!banner) {
    if (lowerTag.endsWith("rides")) {
      banner = RideBanner;
    } else if (lowerTag === "ride") {
      banner = Ride2Banner;
    } else if (studentsBanners[cleanTag]) {
      banner = studentsBanners[cleanTag].image;
    } else if (lowerTag === "market") {
      banner = MarketBanner;
    } else if (lowerTag === "quiz") {
      banner = QuizBanner;
    } else if (lowerTag === "nclexrn") {
      banner = NclexRnBanner;
    } else if (lowerTag === "pebc") {
      banner = PEBCBanner;
    } else if (lowerTag === "rexpn") {
      banner = RexPnBanner;
    } else {
      banner = DefaultBanner;
    }
  }

  // --- Title ---
  let title = "";

  if (lowerTag === "nclexrn") {
    title = "NCLEX-RN";
  } else if (lowerTag === "pebc") {
    title = "PEBC";
  } else if (lowerTag === "rexpn") {
    title = "REx-PN";
  } else {
    // Default capitalization: first letter uppercase
    title = cleanTag.charAt(0).toUpperCase() + cleanTag.slice(1);

    // Special formatting for student hashtags
    if (studentsHashtags[cleanTag]) {
      if (title.length > 2) {
        title = formatHashtagDisplay(title);
      } else {
        title = title.toUpperCase();
      }
    }
  }
  const rules = hashtagData?.rules || null;

  // Override with DB display name if available
  const displayName = hashtagData?.displayName || title;
  return {
    title: displayName,
    desc,
    banner,
    rules,
  };
};
